import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
import NeedHelpButton from "@/components/need-help-button/need-help-button";

import callCenter from "@/assets/images/call-center.svg";
import { Button } from "@/components/ui/button";

type BlockedInputProps = {
  faqAnchor: string;
};

export default function Blocked(props: BlockedInputProps) {
  const { t } = useTranslation();
  const history = useHistory();

  const goToMenu = () => {
    history.push("/site-credentials");
  };

  return (
    <div className="flex flex-col gap-12 pb-2">
      <Header
        title={t("blocked_page.header_title")}
        subtitle={t("blocked_page.subtitle")}
      />
      <div className="flex justify-center items-center">
        <img src={callCenter} alt="Callcenter image" />
      </div>
      <NeedHelpButton anchor={props.faqAnchor} />
      <Button
        type="button"
        variant="secondary"
        onClick={async () => {
          goToMenu();
        }}
      >
        {t("common.back")}
      </Button>
      <div
        role="note"
        aria-label={t("accessibility.signin.icons")}
        className="flex flex-col">
        <Footer />
      </div>
    </div>
  );
}